import { useLocation } from 'react-router-dom'
import { getLang } from '@/lib/lang'
import { blocksUiFor } from '@/data/blocks.en'
// Source: D:/AI/site-queensbutler/public/design-patterns.html — A-1a / A-1b / A-2a / A-2b / A-3a / A-3b
import type { SyntheticEvent } from 'react'
import { Link } from 'react-router-dom'
import { Picture } from '@/components/Picture'
import { serviceNav, type ServiceKey } from '@/data/nav'
import { decoExists } from '@/lib/images'
import type { BillboardContent } from '@/lib/contentTypes'

interface BillboardProps { billboard: BillboardContent; h1: string; h1Sub?: string; service?: ServiceKey | null }
const hideMissing = (event: SyntheticEvent<HTMLImageElement>) => { event.currentTarget.style.display = 'none' }

function Deco({ src, className, alt = '' }: { src: string; className: string; alt?: string }) {
  if (!decoExists(src)) return null
  return <Picture src={src} className={className} alt={alt} aria-hidden={alt ? undefined : true} onError={hideMissing} />
}

function Action({ billboard, light = false }: { billboard: BillboardContent; light?: boolean }) {
  return billboard.cta ? <Link className={`btn ${light ? 'ghost-w' : 'fill'} arrow`} to={billboard.cta.href}>{billboard.cta.label}</Link> : null
}

export function Billboard({ billboard, h1, h1Sub, service = null }: BillboardProps) {
  const t = blocksUiFor(getLang(useLocation().pathname))
  const { pattern, image, alt = '', eyebrow = "Queen's Butler", sub } = billboard
  const config = service ? serviceNav[service] : null

  if (pattern === 'A-1b') return <div className="shell"><div className="hero-cameo">
    <div><div className="eyebrow">{eyebrow}</div><h1 className="h-disp h-1 billboard-heading">{h1}</h1>{h1Sub && <p className="h-disp billboard-subheading">{h1Sub}</p>}{sub && <p className="txt billboard-copy">{sub}</p>}<Action billboard={billboard} /></div>
    {image && <div className="cameo-wrap"><div className="cameo"><Picture src={image} alt={alt} applyFocalPosition={false} /></div><div className="rose"><Picture src="/img/catalog/set.jpg" alt={t.roseAlt} /></div></div>}
  </div></div>

  if (pattern === 'A-2b') return <div className="hero-split">
    <div className="l billboard-split-copy"><div className="eyebrow">{eyebrow}</div><h1><span className="en-disp svc-lockup">{config?.lockup ?? h1}</span><span className="h-disp billboard-service-ja">{h1Sub ?? h1}</span></h1>{sub && <p className="txt billboard-copy">{sub}</p>}<Action billboard={billboard} light /></div>
    {image && <div className="r"><Picture src={image} alt={alt} applyFocalPosition={false} /></div>}
  </div>

  // Yuichi 2026-09-16/17「全ページビルドボードの画像は必須なんだよ」: 規約・フォーム型(A-3b)も画像付きで出す
  if (pattern === 'A-3a' || pattern === 'A-3b') return <div className="bill">
    {image && <Picture src={image} alt={alt} fetchPriority="high" applyFocalPosition={false} />}<div className="veil" /><div className="shell"><div className="eyebrow">{eyebrow}</div><h1 className="h-disp h-2 billboard-lower-heading">{h1}</h1>{h1Sub && <p>{h1Sub}</p>}</div>
  </div>


  const serviceTop = pattern === 'A-2a'
  return <div className={`hero${serviceTop ? ` hero-${service ?? 'salon'}` : ''}`}>
    {image && <Picture src={image} alt={alt} className="bg" fetchPriority="high" applyFocalPosition={false} />}
    <div className="veil" />
    <Deco src="/img/deco/rose_corner_tl" className="rose-corner" />
    <div className="shell">
      {serviceTop ? <h1><span className="en-disp svc-lockup">{config?.lockup ?? h1}</span><span className="billboard-qb">Queen's Butler</span><span className="h-disp billboard-service-ja">{h1Sub ?? h1}</span></h1> : <><div className="eyebrow">{eyebrow}</div><h1 className="h-disp h-1 billboard-heading">{h1}</h1>{h1Sub && <p className="h-disp billboard-subheading">{h1Sub}</p>}</>}
      {sub && <p className="sub">{sub}</p>}<Action billboard={billboard} light />
    </div>
    {!serviceTop && <div className="down" aria-hidden="true">↓</div>}
  </div>
}
